const dev = {
  baseURL: "http://localhost:8072",
};

const prod = {
  baseURL: "https://abdel.matjarepos.com",
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default config;